import { render } from "./ResetPass.vue?vue&type=template&id=124841b4&scoped=true"
import script from "./ResetPass.vue?vue&type=script&lang=js"
export * from "./ResetPass.vue?vue&type=script&lang=js"

import "./ResetPass.vue?vue&type=style&index=0&id=124841b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124841b4"]])

export default __exports__